import { AchievementDefFilter } from "./achievment-def.filter";


export class MedalDefFilter extends AchievementDefFilter {

    last_day?: Date;
    first_day?: Date;
    
}